import { render } from "./VariablesButton.vue?vue&type=template&id=783d224c"
import script from "./VariablesButton.vue?vue&type=script&lang=ts"
export * from "./VariablesButton.vue?vue&type=script&lang=ts"
script.render = render

export default script